define(function (require) {
    'use strict';

    var LPTModel = require('vendor/Backbone/LPTModel');

    return LPTModel.extend({});
});